import { useLoaderData } from 'react-router';
import { useAuth } from '../../public/site/AuthProvider';
import { CaseDetails } from '../CaseDetails/CaseDetails';
import type { SupportCaseLoaderResponse } from '../../common/loaders';

export const SupportCasePath = () => {
  const { supportCase, history } = useLoaderData() as SupportCaseLoaderResponse;
  const { authenticatedUser } = useAuth();
  return <CaseDetails supportCase={supportCase} history={history} authenticatedUser={authenticatedUser} />;
};
